import { useEffect } from "react";
import { api } from "@/lib/api";

function addScript(id, src, attrs = {}) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  if (src) s.src = src;
  s.async = true;
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
  document.head.appendChild(s);
}

function addInline(id, code) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.text = code;
  document.head.appendChild(s);
}

// Loads admin-configured tracking (GA4, GTM, Ads, Meta Pixel, Clarity) on the public site.
export function Analytics() {
  useEffect(() => {
    let cancelled = false;
    api.get("/site-config").then(({ data }) => {
      if (cancelled || !data) return;

      if (data.ga4_id) {
        addScript("ga4-src", `https://www.googletagmanager.com/gtag/js?id=${data.ga4_id}`);
        addInline("ga4-init", `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${data.ga4_id}');`);
      }
      if (data.google_ads_id) {
        addScript("ads-src", `https://www.googletagmanager.com/gtag/js?id=${data.google_ads_id}`);
        addInline("ads-init", `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${data.google_ads_id}');`);
      }
      if (data.gtm_id) {
        addInline("gtm-init", `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${data.gtm_id}');`);
      }
      if (data.meta_pixel_id) {
        addInline("meta-pixel", `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${data.meta_pixel_id}');fbq('track','PageView');`);
      }
      if (data.clarity_id) {
        addInline("clarity-init", `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","${data.clarity_id}");`);
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return null;
}
